import React from "react";
import imageOne from "../../resource/dana/instructions/2.png";
import imageThree from "../../resource/dana/instructions/1.png";
import TitleChnage from "../../Hook/TitleChnage";
import imageFour from "../../resource/dana/instructions/photo.jpeg";

const DanaInstructions = () => {
  TitleChnage("Instructions");
  return (
    <div className="instructions-page inside-pages">
      <div className="right-box">
        <img
          src={imageOne}
          alt="Right Top Image"
          className="right-image"
          width={300}
        />
      </div>

      <h1 className="mt-4 font-light font-main p-4">
        Bhaddeka Vihari Monastery
      </h1>
      <h1 className="mt-4 font-light font-main p-4">and Retreat Centre</h1>
      <h1 className="font-second text-center p-4 mt-5">
        Daily Meal Pooja Guidelines
      </h1>

      <div className="p-4 mt-5">
        <h3 className="h4 mt-6 text-center">Monastery Guidelines</h3>
        <p className="h4 mt-5 ">
          All devotees must adhere to the following guidelines while staying on
          the premises of Bhaddeka Vihari Monastery and Meditation Centre:
        </p>

        <p className="h4 mt-4">
          <span className="text-bold dark-gold">1. Maintain Noble silence</span>{" "}
          Keep a respectful silence throughout the premises.
        </p>

        <p className="mt-4 h4">
          <span className="text-bold dark-gold">2. No Smoking</span> Smoking is
          strictly prohibited
        </p>
        <p className="mt-4 h4">
          <span className="text-bold dark-gold">
            3. Strict Prohibition of Alcohol, Tobacco, and Drugs
          </span>{" "}
          The use of alcohol, tobacco, or any recreational drugs is strictly
          forbidden.
        </p>
        <p className="mt-4 h4">
          <span className="text-bold dark-gold">4. Dress Modestly</span>Please
          wear modest clothing while on the Meditation Centre premises. Short
          trousers, singlets, and revealing clothing are not permitted.
        </p>
        <p className="mt-4 h4">
          <span className="text-bold dark-gold">5. Wear White Clothing</span> To
          maintain the tranquility of the premises, please wear white clothing.
        </p>
        <p className="mt-4 h4">
          <span className="text-bold dark-gold">6. Maintain Calmness</span>{" "}
          Ensure a peaceful atmosphere for yourself and others by switching off
          mobile phones.
        </p>
        <p className="mt-4 h4">
          <span className="text-bold dark-gold">7. Children Safety</span> If
          children accompany devotees, please ensure their safety and supervise
          them closely, as the premises is large
        </p>
        <p className="mt-4 h4">
          <span className="text-bold dark-gold">8. Parking</span> Ensure that
          vehicles are parked in the designated parking area
        </p>

        <div className="meal mt-6">
          <h3 className="h4 mt-5">Daily Meal Pooja Task List</h3>
          <p className="h4 mt-4">
            Please note the following instructions for the day of Meal Dana
            offering.
          </p>

          <h3 className="h5 mt-6 text-center">Breakfast Dana offering</h3>

          <p className="h4 mt-4">
            Arrive at the Monastery by 6:00 AM to allow ample time for
            preparation. The kitchen in the Sangha residence is available for
            warming up meals.
          </p>

          <h3 className="h4 mt-5">Breakfast Dana Task List:</h3>
          <div className="mission-page-section-two">
            <h2 className="mt-4">1. Buddha Pooja Preparation:</h2>
            <p className="mt-4 h4">
              -Prepare and offer the Buddha Pooja by 6:20 AM at the Sangha
              residence.
            </p>

            <h2 className="mt-4">2. Sangha Dana Preparation:</h2>
            <p className="mt-4 h4">
              -Have the Sangha Dana ready at the Sangha residence Dana table by
              6:30 AM.
            </p>
            <p className="mt-4 h4">
              -Offer each food item to the hand of the Sangha member who will
              arrive to accept them and ensure not to touch them afterwards.
            </p>
            <p className="mt-4 h4">
              -The Sangha will then dish out the food items themselves into
              their Parthra.
            </p>

            <h2 className="mt-4">3. Post-Meal Cleanup:</h2>
            <p className="mt-4 h4">
              -Ensure all items (dishes, cutlery, pans, etc.) used are washed,
              dried, and placed in the appropriate cupboard.
            </p>

            <p className="mt-4 h4">-Wipe and clean all benches.</p>
            <p className="mt-4 h4">
              -Remove and properly dispose of all leftover food items and
              rubbish.
            </p>
            <p className="mt-4 h4">-Sweep the floor.</p>
          </div>

          <div className="vinyaRule-box mt-6">
            <div className="left-column">
              <h2 className="mt-4">Vinaya Rule</h2>
              <p className="h4 mt-4">
                A special Vinaya rule, known as the “Kappiyan” process, is
                applied to food items containing edible fertile parts such as
                seeds, vines, roots, or stalks. It is prohibited for the
                Upasampada Sangha to consume these food items without performing
                this special Vinaya action. Some of these food items include:
              </p>
              <ul className="unorderd-list mt-4 h4">
                <li>
                  Seed-bearing fresh fruits and vegetables (e.g., tomatoes, ripe
                  chilies, fruits such as guava, pomegranates, etc.)
                </li>
                <li>
                  Food containing fresh plant vines (e.g., sweet potatoes, Gotu
                  Kola, Mukunuwanna)
                </li>
                <li>
                  Food containing fresh tree branches and stalks (e.g., sugar
                  cane)
                </li>
                <li>
                  Food containing fresh root-bearing plants (e.g., yams, onions,
                  sweet potatoes, potatoes, etc.)
                </li>
              </ul>
            </div>
            <div className="right-column">
              <img src={imageFour} alt="" style={{ width: "100%" }} />
            </div>
          </div>

          <h3 className="h4 mt-6">Vinaya Action</h3>
          <ul className="unorderd-list mt-4 h4">
            <li>
              Before offering, the devotee must hold the dish or tray containing
              the food item.
            </li>
            <li>
              The Upasampada Sangha member will instruct the devotee by saying,
              “Kappiyan Karothi,” meaning “cut the food” to make the food
              allowable.
            </li>
            <li>
              The devotee then pierces the surface of the food item three times
              with a knife while chanting “Kappiyan Bhante,” meaning "I am
              cutting the food, Venerable Sir," to make it allowable.
            </li>
            <li>
              Afterward, the devotee offers the dish to the Upasampada Sangha.
            </li>
            <li>
              Serve food items to the Sangha's Pathra until it is fully covered.
            </li>
          </ul>
          <p className="mt-6 h4">
            Please note that many donors find difficulty to stay long therefore
            no Anumodana session to donors hold after morning Dana. If any donor
            would like to receive Anumodana session in person inform it to a
            Sangha member.
          </p>
          <img
            src={imageFour}
            alt=""
            style={{ width: "100%" }}
            className="mt-6"
          />
          <h3 className="h5 mt-6 text-center">Lunch Dana offering</h3>
          <p className="h4 mt-4">
            Arrive at the Monastery by 10:00 AM to allow ample time for
            arranging the Buddha Pooja and preparing the place for Pindapatha.
            The kitchen in the Dana Sala is available for cooking or warming up
            meals.
          </p>

          <h3 className="h4 mt-5">Lunch Dana Task List:</h3>

          <div className="mission-page-section-two">
            <h2 className="mt-4">1. Arrange the Dana table:</h2>
            <p className="mt-4 h4">
              -Place the meal containers on the Dana Sala table, ensuring each
              food item has a dish and spoon.
            </p>

            <h2 className="mt-4">2. Buddha Pooja Preparation:</h2>
            <p className="mt-4 h4">
              -Buddha Pooja containers are stored in the cupboard marked “Buddha
              Pooja.”
            </p>
            <p className="mt-4 h4">
              -Prepare the Buddha Pooja tray and have it ready to offer by 10:45
              AM in the Sangha residence.
            </p>

            <h2 className="mt-4">3. Sangha Dana Preparation:</h2>
            <p className="mt-4 h4">
              -Ensure the Sangha Dana is warmed up and ready on the Dana Sala
              table by 11:00 AM.
            </p>
            <p className="mt-4 h4">
              -At 11:00 AM, the Sangha will arrive at the Dana Sala for
              Pindapatha.
            </p>
            <p className="mt-4 h4">
              -As mentioned earlier, seed-bearing plants must follow the
              “Kappiyan” process.
            </p>

            <h2 className="mt-4">Vinaya Rule</h2>
            <p className="mt-4 h4">
              A special Vinaya rule, known as the “Kappiyan” process, is applied
              to food items containing edible fertile parts such as seeds,
              vines, roots, or stalks. It is prohibited for the Upasampada
              Sangha to consume these food items without performing this special
              Vinaya action. Some of these food items include:
            </p>

            <p className="mt-4 h4">
              • Seed-bearing fresh fruits and vegetables (e.g., tomatoes, ripe
              chilies, fruits such as guava, pomegranates, etc.)
            </p>

            <p className="mt-4 h4">
              • Food containing fresh plant vines (e.g., sweet potatoes, Gotu
              Kola, Mukunuwanna)
            </p>
            <p className="mt-4 h4">
              • Food containing fresh tree branches and stalks (e.g., sugar
              cane)
            </p>
            <p className="mt-4 h4">
              • Food containing fresh root-bearing plants (e.g., yams, onions,
              sweet potatoes, potatoes, etc.)
            </p>

            <h2 className="mt-4">Vinaya Action</h2>

            <p className="mt-4 h4">
              • Before offering, the devotee must hold the dish or tray
              containing the food item.
            </p>

            <p className="mt-4 h4">
              • The Upasampada Sangha member will instruct the devotee by
              saying, “Kappiyan Karothi,” meaning “cut the food” to make the
              food allowable
            </p>
            <p className="mt-4 h4">
              • The devotee then pierces the surface of the food item three
              times with a knife while chanting “Kappiyan Bhante,” meaning "I am
              cutting the food, Venerable Sir," to make it allowable.
            </p>
            <p className="mt-4 h4">
              • Afterward, the devotee offers the dish to the Upasampada Sangha.
            </p>

            <h2 className="mt-4">4. Offering Desserts and Fruits:</h2>
            <p className="mt-4 h4">
              -If there are any desserts or fruits to be offered, take them to
              the Sangha residence, after Pindapatha.
            </p>

            <h2 className="mt-4">5. Dhamma Talk and Anumodana:</h2>
            <p className="mt-4 h4">
              -A Dhamma talk and anumodana will be given at 12:30 PM at the
              Sangha residence.
            </p>

            <h2 className="mt-4">6. Post-Meal Cleanup:</h2>
            <p className="mt-4 h4">
              -Wash, dry, and place all used dishes, cutlery, and pans in the
              appropriate cupboards.
            </p>
            <p className="mt-4 h4">
              -Wipe and clean all Dana Sala and kitchen benches, as well as
              cooktops.
            </p>
            <p className="mt-4 h4">
              -Remove and dispose of all leftover food and rubbish.
            </p>
            <p className="mt-4 h4">
              -Return tables and chairs to their original places.
            </p>
            <p className="mt-4 h4">
              -Clean the toilets and refill toilet paper if necessary.
            </p>
            <p className="mt-4 h4">-Sweep and mop all floors.</p>
          </div>

          <h2 className="mt-6">Additional Notes:</h2>
          <p className="mt-4 h4">
            1. It is appreciated if you can take a rubbish bag home.
          </p>
          <p className="mt-4 h4">
            2. If the weather is good and many devotees are present,
            arrangements can be made to offer rice Pindapatha to the Sangha when
            they arrive at the Dana Sala.
          </p>

          <div className="">
            <h2 className="mt-4">Rice Pindapatha Instructions:</h2>
            <p className="mt-4 h4">
              1. Prepare small rice plates with a spoon and distribute them to
              each devotee.
            </p>
            <p className="mt-4 h4">
              2. Devotees can offer rice to the Sangha by placing a spoonful of
              rice into the Sangha's Pathra.
            </p>
          </div>

          <h2 className="mt-6 text-center">
            You're very welcome! I sincerely appreciate your kind words. If you
            need any further assistance, feel free to reach out.
          </h2>
        </div>
      </div>
      <div className="bottom-box mt-5">
        <img src={imageThree} alt="bottom-image" width={600} />
      </div>
    </div>
  );
};

export default DanaInstructions;
